export const parseUser = (rawUser) => {
  return {
    id_token: rawUser.id_token,
    name: rawUser.user_claims.filter((a) => a.typ == "name")[0].val,
    user_claims: rawUser.user_claims,
    user_id: rawUser.user_id
  }
}
